<template>
    <div class="ml-1">
        <button 
            v-on:click="toggleFilter" 
            class="product-filter"
            :id="'term--'+value" 
            :class="{active : isActive}"
            ><span>{{name}}</span>
        </button>
        <ul v-if="isActive && subs.length > 0" class="nav flex-column ml-1 mb-1">
            <li v-for="(filter, index) in subs" :key="index">
                <ProductParentFilter v-bind="filter" />
            </li>
        </ul>
    </div>    
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { FilterType } from "../@types/Filters"
import ProductParentFilter from './ProductParentFilter.vue'

export default {
    data() {
        return  {
            active : false
        }
    },
    props: {
        id: {
            type: Number,
            default: null
        },
		name: {
			type : String,
			required : true
		},
		value: {
			type : [String, Number],
            default: null
		},
        handle: {
            type: String,
            required: true
        },
        subs: {
            type: Array,
            default: () => []
        },
		slug: String
    },
    components: {
        ProductParentFilter
    },
    computed : {
        ...mapGetters({
            filters: 'getFilters'
        }),
        filterValue() {
            return this.handle == 'category' ? this.id : this.value
        },
        isActive() {
            return this.filters.filter(term => term.handle == this.handle && term.value == this.value).length > 0
        }
    },
    methods : {
        ...mapActions([
            'addFilter',
            'removeFilter'
        ]),
        ...mapGetters([
            'isUpdated',
            'hasActiveFilters'
        ]),
        toggleFilter() {  
            let payload = {
                type: FilterType.Taxonomy,
                value: this.value,
                handle: this.handle,
                name: this.name
            }
            if (this.isActive) {
                this.removeFilter(payload)
            } else {
                this.addFilter(payload)
            }
        }
    },

}
</script>